<template>
    <div>
        <config-main-title>
            Medicamentos
        </config-main-title>

        <div class="form-row mb-2">
            <div class="col col-12 col-md-3">
                <az-input 
                    placeholder="Todos..."
                    icon="fa-solid fa-filter fa-fw" 
                    type="select" 
                    :optionsList="options_classes.map(item => { 
                        return { id: item, search: item };
                    })"
                    optionsData="id"
                    v-model="tag_selecionada" 
                    @change.native="load()" />
            </div>
            <div class="col col-12 col-md-3" v-if="medico_base">
                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-user-md fa-fw"></i>
                        </span>
                    </div>
                    <label class="form form-control" disabled>{{ $store.state.user.medico.search }}</label>
                </div>
            </div>
            <div class="col col-12 col-md-3" v-else>
                <az-input 
                    placeholder="Geral"
                    icon="fas fa-user-md fa-fw" 
                    type="select" 
                    optionsMode="aql"
                    service="medicos.index"
                    optionsName="medicos-cadastro"
                    :optionsParm="{ ativos: true }"
                    optionsData="id_pessoa"
                    v-model="id_medico" 
                    @change.native="load()" />
            </div>

            <div class="col col-12 col-md-3">
                <i class="" aria-hidden="true"></i>
                <az-input
                    icon="fa fa-filter"
                    placeholder="Escopo..."
                    type="select"
                    :optionsList="[
                        { id: 'R', search: 'Receita' },
                        { id: 'P', search: 'Prescrição' },
                    ]"
                    optionsData="id"
                    v-model="tipo_escopo"
                    @change.native="load()" />
            </div>

            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'; load();">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'; load();">
                        Todos
                    </button>
                </div>
            </div>
        </div>

        <div class="form-row mb-3">
            <div class="col col-12">
                <az-input icon="fas fa-search fa-fw" v-model="search" @input="buscar()" placeholder="Pesquisar...">
                    <template v-slot:buttonposb>
                        <importacao service="medicamentos" @refresh="load()" :parms="{ pep: true }" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-primary" @click="incluir ()" title="Incluir">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <template v-if="!dados || !dados.data || !dados.data.length">
            <az-empty-state msg="Nenhum documento criado." />
        </template>

        <ul class="list-group" v-else>
            <li class="list-group-item" v-if="dados.last_page > 1">
                <nav>
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </nav>
            </li>
            <li class="list-group-item d-flex justify-content-between" v-for="(medicamento, imedicamento) in dados.data" :key="imedicamento">
                <template v-if="( medico_base && medicamento.id_medico == medico_base ) || ( !medico_base )">
                    <div>
                        <a href="#" @click.prevent="editar(medicamento)" class="card-link">
                            {{ medicamento.search }}
                        </a>
                        <span class="badge badge-secondary ml-1">#{{ medicamento.id_medicamento }}</span>
                        <span v-if="medicamento.apresentacao" class="text-muted ml-3">{{ medicamento.apresentacao.search }}</span>
                        <small v-if="medicamento.st_posologia" class="text-muted ml-3">{{ medicamento.st_posologia }}</small>
                        <div>
                            <span class="badge badge-success mr-1" v-for="(classe, icx) in medicamento.js_classes" :key="icx">
                                {{ classe }}
                            </span>
                        </div>
                    </div>
                    <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                        <input type="checkbox" class="custom-control-input" 
                            :id="'ativo-' + imedicamento" 
                            v-model="medicamento.fl_ativo" 
                            @change="toggle(medicamento)">
                        <label class="custom-control-label" :for="'ativo-' + imedicamento"></label>
                    </div>
                    <div v-else class="d-flex">
                        <div v-if="medicamento.st_agrupa">
                            <span class="badge badge-success">
                                {{ medicamento.st_agrupa }} 
                            </span>
                        </div>

                        <div v-if="medicamento.item_kit_medicamentos_count" class="ml-3">
                            <a href="#" @click.prevent="ver_kits(medicamento)" title="Kits com o Medicamento">
                                <span class="badge badge-primary">
                                    {{ medicamento.item_kit_medicamentos_count }} 
                                    <i class="fa fa-boxes fa-fw ml-1" aria-hidden="true"></i>
                                </span>
                            </a>
                        </div>

                        <div v-if="medicamento.estoque_items_count" class="ml-3">
                            <a href="#" @click.prevent="ver_estoque_items(medicamento)" title="Vinculo com Suprimentos">
                                <span class="badge badge-primary">
                                    {{ medicamento.estoque_items_count }} 
                                    <i class="fa-solid fa-box-open fa-fw ml-1"></i>
                                </span>
                            </a>
                        </div>

                        <h5 class="mb-0 ml-3" v-if="medicamento.fl_controle_especial">
                            <i class="fa-solid fa-file-prescription" title="Receituário de Controle Especial"></i>
                        </h5>

                        <span v-else-if="medicamento.st_escopo == 'R'">
                            <i class="fas fa-prescription text-primary ml-3" title="Receita"></i>
                        </span>
                        <span v-else-if="medicamento.st_escopo == 'P'">
                            <i class="fas fa-pills text-primary ml-3" title="Prescrição"></i>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <div>
                        {{ medicamento.search }}
                    </div>
                    <div v-if="viewMode == 'T'">
                        {{ medicamento.fl_ativo ? 'Ativo' : 'Inativo' }} 
                    </div>
                </template>
            </li>
        </ul>

        <!-- Modal -->
        <div class="modal fade" id="editarMedicamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Medicamento
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_medicamento"> 
                                #{{ item.id_medicamento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Descrição"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_medicamento" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Agrupamento na Receita/Prescrição"
                                    placeholder="Nenhum..."
                                    :validate="validate"
                                    v-model="item.st_agrupa" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Escopo"
                                    placeholder="Selecione..."
                                    type="select"
                                    :optionsList="[
                                        { id: 'G', search: 'Geral' }, 
                                        { id: 'P', search: 'Prescrição' },
                                        { id: 'R', search: 'Receita' }, 
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_escopo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Quantidade Padrão"
                                    type="number"
                                    placeholder="Não definida..."
                                    :validate="validate"
                                    v-model="item.in_quantidade" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Apresentação"
                                    type="select"
                                    optionsMode="aql"
                                    service="apresentacoes.index"
                                    optionsData="id_apresentacao"
                                    :validate="validate"
                                    v-model="item.id_apresentacao" />
                            </div>
                        </div>

                        <!-- Id 49 = Apresentação Percentual = Usado em Fórmulas -->
                        <template v-if="item.id_apresentacao != 49">

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Posologia"
                                        :validate="validate"
                                        v-model="item.st_posologia" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Outras Posologias"
                                        :validate="validate"
                                        v-model="item.tem_posologias">
                                        <template v-slot:buttonposcb v-if="item.tem_posologias">
                                            <div class="input-group-append" v-if="item.tem_posologias">
                                                <button type="button" class="btn btn-outline-primary" @click="incluir_posologia()">
                                                    <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <template v-if="item.tem_posologias && item.js_posologias">
                                <div class="row" v-for="(posologia, ipx) in item.js_posologias" :key="ipx">
                                    <div class="col col-12">
                                        <az-input
                                            sizing="sm"
                                            :validate="validate"
                                            required
                                            v-model="posologia.texto">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-danger" @click="item.js_posologias.splice(ipx, 1)">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>
                            </template>

                        </template>

                        <div class="row mt-3" vif="item.id_apresentacao == 11 || item.fl_diluente">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Diluente"
                                    :validate="validate"
                                    v-model="item.fl_diluente" />
                            </div>
                        </div>

                        <template v-if="tem_prescricao && item.unidade && item.unidade.fl_ativo && item.st_escopo != 'R'">

                            <az-sub-title title="Prescrição" class="mt-3"></az-sub-title>

                            <div class="form-row mt-1" v-if="!item.fl_diluente">
                                <div class="col col-12" :class="item.fl_info_dil ? 'col-md-6' : ''">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Informar Diluente"
                                        :validate="validate"
                                        v-model="item.fl_info_dil" />
                                </div>

                                <div class="col col-12 col-md-6" v-if="item.fl_info_dil">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        icon="fa-solid fa-droplet-percent"
                                        optionsMode="aql"
                                        service="medicamentos.index"
                                        optionsDisplay="search"
                                        optionsData="id_medicamento"
                                        :optionsParm="{ diluente: 1, pep: 1 }"
                                        placeholder="Diluente..."
                                        v-model="item.id_med_dil">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.id_med_dil">
                                                <span class="input-group-text">#{{ item.id_med_dil }}</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Informar Via/Uso na Prescrição"
                                        :validate="validate"
                                        v-model="item.fl_info_via_uso" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.fl_info_via_uso">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :compact="true"
                                        label="Via"
                                        optionsMode="aql"
                                        service="prescricao_vias.index"
                                        :optionsParm="{ ativos: true }"
                                        optionsDisplay="search"
                                        optionsData="id_prescricao_via"
                                        placeholder="Via..."
                                        v-model="item.id_prescricao_via" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :compact="true"
                                        label="Uso"
                                        optionsMode="aql"
                                        service="prescricao_usos.index"
                                        :optionsParm="{ ativos: true }"
                                        optionsDisplay="search"
                                        optionsData="id_prescricao_uso"
                                        placeholder="Uso..."
                                        v-model="item.id_prescricao_uso" />
                                </div>
                            </div>

                        </template>

                        <az-sub-title title="Observação" class="mt-3"></az-sub-title>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>

                        <div class="mt-3">
                            <multiselect
                                v-model="item.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma região selecionado.
                                </template>
                            </multiselect>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Receituário de Controle Especial"
                                    :validate="validate"
                                    v-model="item.fl_controle_especial" />
                            </div>
                        </div>

                        <div class="row" v-if="item.unidade">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Ativo para o Faturamento"
                                    :validate="validate"
                                    v-model="item.unidade.fl_ativo" />
                            </div>
                        </div>

                        <az-sub-title title="Princípio Ativo" class="mt-3">
                            <a href="#" @click.prevent="incluir_alergia(item)">
                                <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                Incluir
                            </a>
                        </az-sub-title>

                        <div v-if="!item.alergias || !item.alergias.length" class="mt-3">
                            <div>Nenhuma princípio ativo cadastrado.</div>
                        </div>

                        <div class="mt-3" v-else>
                            <div v-for="(alergia, iax) in item.alergias" :key="iax">
                                <div class="form-row" v-show="!alergia.excluido">
                                    <div class="col col-12">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="alergia_tipos.index"
                                            optionsData="id_alergia_tipo"
                                            :validate="validate"
                                            required
                                            v-model="alergia.id_alergia_tipo">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-danger" @click="alergia.excluido = true">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="item.colirios && item.colirios.length">

                            <az-sub-title title="Cobrança Colírios (SUS)" class="mt-3"></az-sub-title>

                            <div class="small">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Descrição</th>
                                            <th>Código (SUS)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(colirio,icx) in item.colirios" :key="icx">
                                            <td>
                                                <a href="#" @click.prevent="$util.abrirProcedimento(colirio)" class="card-link">{{ colirio.id_procedimento }}</a>
                                            </td>
                                            <td>{{ colirio.procedimento.st_procedimento }}</td>
                                            <td>{{ colirio.procedimento.st_codigo_sus }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </template>


                        <br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="medicamento" :id="item.id_medicamento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_medicamento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>        

        <!-- Modal Ver Kits-->
        <div class="modal fade" id="verKitsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Kits / Protocolos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="medicamento_kits">
                        <div class="alert alert-info">
                            {{ medicamento_kits.search}}
                        </div>

                        <ul class="list-group">
                            <li class="list-group-item" v-for="(kit, ikx) in medicamento_kits.kits" :key="ikx">
                                {{ kit.search }}
                                <span class="badge badge-secondary ml-2">#{{ kit.id_kit_medicamento }}</span>
                                <div class="small text-muted" v-if="kit.medico">
                                    {{ kit.medico.search }}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Ver Estoque -->
        <div class="modal fade" id="verEstoqueModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Vinculo Suprimentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="medicamento_estoque">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                {{ medicamento_estoque.search}}
                            </div>
                            <div>
                                #{{ medicamento_estoque.id_medicamento }}
                            </div>
                        </div>

                        <az-sub-title title="Vinculos" class="mt-3"></az-sub-title>
                        <ul class="list-group">
                            <li class="list-group-item" v-for="(estoque_item, ikx) in medicamento_estoque.estoque_items" :key="ikx">
                                {{ estoque_item.search }}
                                <span class="badge badge-secondary ml-2">#{{ estoque_item.id_estoque_item }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../../../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import Importacao from '../../../cadastros/shared/Importacao.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null, 
            item: null,
            validate: false, 
            search: "", 
            timeout: null, 
            viewMode: 'A',
            page: 1, 
            id_medico: "", 
            medicamento_kits: null, 
            medicamento_estoque: null, 
            options_classes: [], 
            tag_selecionada: "", 
            tem_prescricao: false, 
            tipo_escopo: "", 
        }
    },

    props: ['config'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzSubmit,  
        AzEmptyState,
        Importacao, 
        AzAuditLogButton,
        AzSubTitle, 
        Multiselect,
    },  

    watch: { 
        viewMode: function () { 
            this.load();
        }
    },

    computed: { 
        medico_base: function () { 
            if ( this.config )
                return;

            return this.$store.state.user.medico ? this.$store.state.user.id_pessoa : null;
        }
    },
    
    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        ver_kits (medicamento) { 
            this.$util.load(this, { 
                service: 'medicamentos',
                func: 'show',
                parms: { 
                    id: medicamento.id_medicamento, 
                    kits: true, 
                },
                loadTo: res => { 
                    medicamento.kits = _.orderBy(res.item_kit_medicamentos.map(ikm => ikm.kit), 'search');
                    this.medicamento_kits = _.cloneDeep(medicamento);

                    $('#verKitsModal').modal('show');
                }
            });
        },

        ver_estoque_items (medicamento) { 
            this.$util.load(this, { 
                service: 'medicamentos',
                func: 'show',
                parms: { 
                    id: medicamento.id_medicamento, 
                    estoque: true, 
                },
                loadTo: res => { 
                    medicamento.estoque_items = res.estoque_items;
                    this.medicamento_estoque = _.cloneDeep(medicamento);

                    $('#verEstoqueModal').modal('show');
                }
            });
        },

        incluir_posologia () { 
            if ( !this.item.js_posologias ) { 
                this.item.js_posologias = [];
            }

            this.item.js_posologias.push({
                texto: ""
            });
        },

        incluir_alergia (medicamento) { 
            medicamento.alergias.push({
                id_medicamento_alergia: null, 
                id_medicamento: null, 
                id_alergia_tipo: "", 
                excluido: false, 
            });
        },

        paginar(page) { 
            this.load(page);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'medicamentos',
                dados: item,
            });

        },

        buscar() { 
            if (this.timeout) { 
                clearTimeout(this.timeout); 
                this.timeout = null;
            }

            this.timeout = setTimeout(() => {
                this.load ();
            }, 300);
        },

        incluir () { 
            this.validate = false; 
            
            this.editar ({ 
                id_medicamento: null, 
                id_medico: this.medico_base, 
                st_medicamento: "",
                st_posologia: "",
                js_posologias: null, 
                tem_posologias: false, 
                st_observacao: "", 
                id_apresentacao: "",
                fl_ativo: true,
            });
        },

        editar (item) { 
            this.validate = false; 

            if ( !item.unidade ) { 
                item.unidade = {
                    fl_ativo: false,
                }
            }

            if ( item.id_medicamento ) { 
                this.$util.load(this, { 
                    service: 'medicamentos',
                    func: 'show',
                    parms: { 
                        id: item.id_medicamento, 
                        cadastro_pep: true,
                        cadastro: true, 
                        edicao: true, 
                    },
                    loadTo: res => { 
                        item = res; 
                        this.item = _.cloneDeep(item);
                        $('#editarMedicamentoModal').modal('show');
                    }
                }); 
            } else {
                this.item = _.cloneDeep(item);
                $('#editarMedicamentoModal').modal('show');
            }

        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'medicamentos',
                dados: { 
                    ...this.item,
                    cadastro_pep: true
                },
                modal: 'editarMedicamentoModal',
                reload: true, 
            })

        },

        load (page = 1) { 
            this.$util.load(this, { 
                service: 'pep_medicamentos', 
                parms: { 
                    search: this.search,
                    cadastro_pep: true,
                    size: 20, 
                    page: page,
                    mode: this.viewMode,
                    id_medico: this.id_medico,
                    cadastro: true, 
                    tag: this.tag_selecionada,
                    escopo: this.tipo_escopo, 
                },
                configs: [
                    'prescricao', 
                ], 
                loadTo: res => { 
                    this.dados = res;
                    this.tem_prescricao = !!this.$store.state.contexto['prescricao'];
                }
            });
        }
    },

    mounted () { 
        if ( this.config ) { 

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Medicamentos", path: "/medicamentos" },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

        this.$util.loadItem(this, { 
            service: 'medicamentos',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.load ();
    }

}
</script>